import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {toast} from "react-toastify";
import { fetchEntityById, modifyEntity } from "../../../actions/entities";
import { entityByIdSelector } from "../../../reducers/entity";
import RefDropdown from "../../widgets/RefDropdown";
import {allProps, endpointFindById, endpointModify, entityCanModify, prop} from "../../../utils/metaUtil";
import {allMetaSelector} from "../../../reducers/meta";

class EntityPage extends React.Component {
  state = {
    data: {},
    loading: false,
    errors: {}
  };

  componentWillMount() {
    if (this.props.entity) {
      this.setDefaultState(this.props.entity);
    }
  }
  componentDidMount = () => this.onInit(this.props);
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.match.params.entityType !== this.props.match.params.entityType
    ) {
      this.onInit(nextProps);
      this.setDefaultState(nextProps.entity);
    }
  }
  onInit = props => {
    const entityType = props.match.params.entityType;
    const entityId = props.match.params.entityId;
    props.fetchEntityById(
      entityType,
      endpointFindById(props.meta, entityType),
      entityId
    );
  };
  onChange = e =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value }
    });

  onSubmit = event => {
    const entityType = this.props.match.params.entityType;
    const entityId = this.props.match.params.entityId;
    event.preventDefault();
    this.props.modifyEntity(
      this.props.meta,
      entityType,
      entityId,
      this.state.data,
      endpointModify(this.props.meta, entityType)
    )
        .then(()=>{toast.success(`${entityType} saved`, {position: toast.POSITION.BOTTOM_RIGHT});this.props.history.push(`/entity/${entityType}`)});
  };
  setDefaultState(entity) {
    this.setState({
      data: entity
    });
  }
  renderProperty = (meta, canModify, entity, propKey) => {
    const entityType = this.props.match.params.entityType;
    const property = prop(meta, entityType, propKey);
    const displayName = property.display ? property.display : propKey;
    if (property.visible === false) return;
    if (property.type) {
      return (
        <div key={propKey} className="col-sm-4 col-lg-3 mb-3">
          <label>{displayName}</label>
          <input
            name={propKey}
            className="form-control"
            type="text"
            defaultValue={entity[propKey]}
            disabled={property.readonly === true || !canModify}
            onChange={this.onChange}
          />
        </div>
      );
    } else if (property.ref) {
      return (
        <div key={propKey} className="col-sm-4 col-lg-3 mb-3">
          <label>{displayName}</label>
          <RefDropdown
            enabled={canModify}
            meta={meta}
            name={propKey}
            value={entity[propKey]}
            entityType={property.ref}
            disabled={property.readonly === true || !canModify}
            onChange={this.onChange}
          />
        </div>
      );
    }
  };
  renderEntity = (meta, canModify, entity) => {
    const entityType = this.props.match.params.entityType;
    return (
      <div className="form-row">
        {Object.keys(allProps(meta, entityType)).map(e => {
          return this.renderProperty(meta, canModify, entity, e);
        })}
      </div>
    );
  };

  render() {
    const entityType = this.props.match.params.entityType;
    const {meta} = this.props;
    const canModify=entityCanModify(meta, entityType)
    const { entity } = this.props;
    return (
      <div className="container mt-3">
        <div className="row">
          <div className="col-12">
            <h1>One - {entityType}</h1>
          </div>
        </div>
        {entity && (
          <form onSubmit={this.onSubmit}>
            {this.renderEntity(meta, canModify, entity)}
            <div className="row">
              <div className="col-sm-6">
                <Link to={`/entity/${entityType}`}>
                  <button type="button" className="btn btn-md btn-primary">
                    CLOSE
                  </button>
                </Link>
              </div>
                {canModify &&
                <div className="col-sm-6 text-sm-right">
                    <button type="submit" className="btn btn-md btn-primary">
                        SAVE
                    </button>
                </div>
                }
            </div>
          </form>
        )}
      </div>
    );
  }
}

EntityPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
  fetchEntityById: PropTypes.func.isRequired,
  modifyEntity: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      entityType: PropTypes.string.isRequired,
      entityId: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  entity: PropTypes.shape().isRequired,
  meta: PropTypes.shape().isRequired
};
EntityPage.defaultProps = {};

function mapStateToProps(state, props) {
  return {
    entity: entityByIdSelector(
      state,
      props.match.params.entityType,
      props.match.params.entityId
    ),
    meta: allMetaSelector(state)
  };
}

export default connect(mapStateToProps, { fetchEntityById, modifyEntity })(
  EntityPage
);



// WEBPACK FOOTER //
// ./src/components/pages/entity/EntityPage.js